import {rangeHasType, isFirstLine, previousLineRange} from "../state.js";

export function quotePadding(state, from) {
  if (needsQuotePadding(state, from)) {
    return '\n';
  }
  return '';
}

function needsQuotePadding(state, from) {
  if (isFirstLine(state, from)) {
    return false;
  }
  return rangeHasType(state, previousLineRange(state, from), 'Blockquote');
}
